import CustomLegend from './CustomLegend';

export default CustomLegend;
